/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import firebase from "firebase/app";
import { Link, Redirect } from "react-router-dom";
import TypeChecker from "typeco";
import { useSelector } from "react-redux";
import {
  Container,
  Divider,
  Grid,
  Item,
  Icon,
  Button,
  Input,
  Segment,
  Sidebar,
  Menu,
  Message,
  List,
} from "semantic-ui-react";

import AutoFillModal from "./AutoFillModal";
// import AutoFillModal from "../Temp/formList/AutoFillModal";
import pdfListEnum from "./autoFillEnum.json";
// import pdfFileObject from "../../components/autoFill/pdfForm.json";

function AutoFill() {
  const uid = useSelector((state) => state.firebase.auth.uid);
  const [value, setValue] = useState("");
  const [pdfList, setPdf] = useState([]);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [obj, setObj] = useState({});
  const pdfNames = Object.keys(pdfListEnum);
  useEffect(() => {
    for (let i = 0; i < pdfNames.length; i++) {
      firebase
        .firestore()
        .collection("autoFill")
        .doc(pdfNames[i])
        .get()
        .then((doc) => {
          data[i] = doc.data();
          obj[pdfNames[i]] = doc.data();
          setData([...data]);
          setObj(obj);
        })
        .catch((err) => {
          global.alert(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handleUpload = async () => {
  //   for (let i = 0; i < 8; i++) {
  //     await firebase
  //       .firestore()
  //       .collection("autoFill")
  //       .doc(Object.keys(pdfFileObject)[i])
  //       .set(pdfFileObject[Object.keys(pdfFileObject)[i]])
  //       .catch((err) => {
  //         global.alert(err);
  //       });
  //   }

  //   global.alert("İşlem başarılı");
  // }

  const handleDelete = async (e, { id }) => {
    const removedArray = pdfList.filter((item) => item !== id);
    setPdf(removedArray);
  };
  const handleChange = (e) => {
    setValue(e && e.target && e.target.value);
  };

  if (!uid) return <Redirect to="/signin" />;
  return (
    <Container style={{ height: "84vh" }}>
      <Button
        icon
        floated="right"
        labelPosition="right"
        onClick={() => setVisible(!visible)}
      >
        {!visible ? "OPEN MENU" : "CLOSE MENU"}
        <Icon name={!visible ? "right arrow" : "left arrow"} />
      </Button>
      <br />
      <br />
      <Sidebar.Pushable>
        <Sidebar
          as={Menu}
          animation="scale down"
          direction="right"
          icon="labeled"
          onHide={() => setVisible(false)}
          vertical
          visible={visible}
          width="thin"
        >
          <Menu.Item as={Link} to="/pdf-editor">
            <Icon name="folder" />
            PDF Editor
          </Menu.Item>
          <Menu.Item as={Link} to="/">
            <Icon name="home" />
            Home Page
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pusher>
          <>
            <Input
              size="big"
              onChange={handleChange}
              icon="search"
              placeholder="Search..."
              style={{ width: "100%" }}
            />
            <Divider />
            <Grid stackable columns={2}>
              <Grid.Column width={10}>
                <Segment style={{ overflow: "auto", maxHeight: "68vh" }}>
                  <Item.Group divided>
                    {TypeChecker.isEmpty(value)
                      ? data.map((item) => (
                          <Item key={item.formId}>
                            <Button
                              id={item.formId}
                              onClick={() => {
                                if (pdfList.length === 0) {
                                  setPdf([item.formId, ...pdfList]);
                                } else {
                                  global.alert("You can only one group!");
                                }
                              }}
                            >
                              Choose
                            </Button>
                            <Item.Content>
                              <Message info>
                                <Item.Header
                                  as="a"
                                  target="_blank"
                                  href={item.uscisURL}
                                >
                                  {item.formName}
                                </Item.Header>
                                <Item.Meta>{item.formDescription}</Item.Meta>
                                <Item.Extra>
                                  Edition Date: {item.editionDate}
                                </Item.Extra>
                              </Message>
                            </Item.Content>
                          </Item>
                        ))
                      : data
                          .filter((item) =>
                            item.formDescription
                              .toLowerCase()
                              .includes(value.toLowerCase())
                          )
                          .map((item) => (
                            <Item key={item.formId}>
                              <Button
                                id={item.formId}
                                onClick={() => {
                                  setPdf([item.formId, ...pdfList]);
                                }}
                              >
                                Choose
                              </Button>

                              <Item.Content>
                                <Message info>
                                  <Item.Header
                                    as="a"
                                    target="_blank"
                                    href={item.uscisURL}
                                  >
                                    {item.formName}
                                  </Item.Header>
                                  <Item.Meta>{item.formDescription}</Item.Meta>
                                  <Item.Extra>
                                    Edition Date: {item.editionDate}
                                  </Item.Extra>
                                </Message>
                              </Item.Content>
                            </Item>
                          ))}
                  </Item.Group>
                </Segment>
              </Grid.Column>
              <Grid.Column width={6}>
                <Segment style={{ overflow: "auto", maxHeight: "70vh" }}>
                  {Object.keys(pdfList).length === 0 ? (
                    <Message warning>Form List is empty</Message>
                  ) : (
                    <>
                      <List divided verticalAlign="middle">
                        {pdfList.map((item) => (
                          <>
                            <List.Item key={item}>
                              <List.Content floated="right">
                                <Button
                                  id={item}
                                  color="red"
                                  onClick={handleDelete}
                                >
                                  Remove
                                </Button>
                              </List.Content>
                              <Icon size="big" name="file pdf" />
                              <List.Content verticalAlign="bottom">
                                {obj[item].formName} ({obj[item].pageNo} pages)
                              </List.Content>
                            </List.Item>
                            <Divider />
                            <Message color="olive">
                              {obj[item].autoFillGroup.map((p) => (
                                <>
                                  <a href={p.uscisURL} target="_blank">
                                    {p.formDescription} ({p.formName}){" "}
                                  </a>
                                  <p>Edition Date: {p.editionDate}</p>
                                </>
                              ))}
                            </Message>
                          </>
                        ))}
                      </List>
                      <Divider />

                      <AutoFillModal uid={uid} formArray={pdfList} />
                    </>
                  )}
                </Segment>
              </Grid.Column>
            </Grid>
          </>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Container>
  );
}

export default AutoFill;
